import { Component, Vue } from 'vue-property-decorator';
import DigitalSignCurrentCompanyDialog from "@/feature/Auth/components/DigitalSignCurrentCompanyDialog.vue";

@Component({
	components: {
		DigitalSignCurrentCompanyDialog
	}
})
export default class DigitalSignCurrentCompany extends Vue {

	digitalSignDialog: boolean = false
	
	digitalSignData: any = null

	signData<T>(data: T) {
		this.digitalSignData = data;
		this.digitalSignDialog = true;
	}

}